/* eslint-disable quotes */
// Holandês
export const holandes = {
  start: "Begin",
  configurations: "Instellingen:",
  ramdom: "Willekeurige gamemodus",
  vibration: "Trillingen :",
  startgame: "Start Spel",
  save: "Opslaan",
  delete: "Verwijder",
  update: "Bijwerken",
  lets: "Laten we spelen",
  permanentbuy: "Permanente Aankoop",
  signature: "Maandelijks Abonnement",
  signatureano: "Jaarlijks Abonnement",
  small: "Hier kunt u uw echte naam gebruiken... of een bijnaam :)",
  text1: "Krijg premium toegang en garandeer alle updates",
  text2:
    "Door u te abonneren krijgt u toegang tot de Premium versie wanneer u maar wilt",
  gender: "Gender",
  male: "Mannelijk  ",
  female: "Vrouw",
  ambos: "Zowel",
  fechar: "Sluiten",
  sexualorientation: "Seksuele geaardheid",
  heterosexual: "Heteroseksueel",
  homosexual: "Homoseksueel",
  bisexual: "Biseksueel",
  chooseavatar: "Kies uw avatar",
  Participants: "Deelnemers",
  participant: "Deelnemer Registratie",
  name: "Naam",
  choosecategory: "Kies categorieën",
  categories: "Categorieën",
  light: "Licht",
  preliminary: "Voorrondes",
  oral: "Mondeling",
  anal: "Anaal",
  hot: "Warm",
  extreme: "Extreem",
  vd: "Waarheid ?",
  dare: "Uitdagingen ?",
  truth: "Waarheid",
  time: "Tijd",
  createMyChallenges: "Mijn uitdagingen creëren",
  chosen: "Geselecteerd",
  text3: "Laat de liefde in je stromen!",
  text4: "Maak je klaar om intens te leven",
  close: "Sluiten",
  sele: "Kies een optie",
  dev: "Ontwikkeld door Dev12BR",
  game: "Spel",
  get: "Comprar - R$ 34,99",
  sign: "Assinar - R$ 5,99",
  next: "VOLGENDE",
  config1: "Waarom zou ik de Premium versie kopen ?",
  config2: "Exclusieve categorieën en meer dan 800 nieuwe uitdagingen",
  config3: "Geen advertenties",
  config4: "Kies avatars om op te vrolijken",
  config5: "Creëer je eigen uitdagingen ",
  config6: "Je ondersteunt spelontwikkeling",
  config7: "Waarom kost het spel geld?",
  config8:
    "Om het spel te ontwikkelen heb je tijd nodig! :) Op deze manier kun je het spel altijd ondersteunen, ondersteunen en updaten.",
  config9: "Creëer en bewerk je eigen uitdagingen",
  age: `Dit spel is alleen voor volwassenen, dus je moet minstens 18 jaar oud zijn. Door "Ja" te selecteren, gaat u akkoord met de gebruiksvoorwaarden en het Privacybeleid. 

  Dit spel is geschikt voor koppels, dus je moet met minstens één partner spelen. 
    
  Het is geen dating app, maar een manier om met je partner te spelen.
    `,
  config10: "Exclusieve categorieën",
  config11: "+ 800 nieuwe uitdagingen",
  assessment:
    "Beoordeel het door een opmerking over de app toe te voegen. Uw feedback is erg belangrijk voor ons om het spel zo goed mogelijk te houden.",
  agree: "Ja, ik ben ouder dan 18 jaar",
  noAgree: "Aanvraag sluiten",
  apoio1: "Steun de ontwikkeling door u te abonneren op de Premium versie :)",
  apoio2: "Vergeet niet om de app te beoordelen in de S2 shop",
  apoio3: "Krijg toegang tot alle exclusieve functies in de Premium versie",
  apoio4: "Weg met deze banner - Koop de Premium versie",
  version: "Premium versie",
  version1: "Premium versie",
  alert1: "Registreer gebruikers om te spelen",
  alert2: "Registreer ten minste een andere gebruiker om te spelen",
  alert3: "Kies ten minste één categorie",
  alert4: `🔥 Er zijn deelnemers zonder partners. Minstens twee deelnemers voor elk geslacht 🔞. 
        
Voorbeeld: Twee hetero's, of twee homo's.`,
  tituloAlert1: "⚠️ Het spel gaat beginnen 😜",
  tituloAlert2:
    "⚠️ Jammer 😬, Je zit zonder internet 📶. Zet het internet aan op uw toestel en koop het abonnement, of het definitieve plan. En wees gelukkig.😘.",
  parser: "Geen partner",
  premiumImages: "Word Premium en krijg toegang tot meer avatars",
  duvidas: "Vragen of suggesties - Pittige Uitdagingen",
  description: "Hallo, mijn vraag of suggestie is :",
  texto99:
    "Als u problemen, vragen of suggesties hebt, kunt u ons een e-mail sturen door op deze knop hieronder te klikken. We kijken er naar uit om met u te praten!",
  send: "Verzenden",
  contact: "Neem contact op met",
  botaoApple: "Aankopen herstellen",
  alertCompra: "Uw aankoop wordt hersteld",
  NotPurchase: "Je hebt geen aankopen",
  notPurchase2:
    "Deze link is alleen voor gebruikers die eerdere aankopen hebben gedaan en deze willen terugzetten op een nieuw toestel.",
  termOfPotitic: "Gebruiksvoorwaarden en privacybeleid",
  alertDeuErrado: "Er is iets misgegaan. :(",
  alertDeuErrado2: "Vul alle informatie in",
  alertNome: "Vul in het veld: Naam",
  options: "Opties",
  optionsTitle: "Opties",
  gradualGame: "Geleidelijk spel",
  textoCaixa:
    "Door deze selectie te activeren, zullen de uitdagingen geleidelijk verlopen, d.w.z. van de lichtste tot de meest extreme naargelang uw keuze.",
  comoJogar: "Hoe moet ik spelen? 🤔",
  avalie: "Evalueer",
  novaCategoria: "Mijn categorieën",
  alterLanguage: "Verander Taal ?",
  textLanguage:
    "Bij het wijzigen van de taal wordt de applicatie opnieuw gestart",
  textLanguage1: "Verander Taal",
  cancel: "Annuleren",
  languages: "Talen",
  email: "@email ✉️",
  deletCat: "Categorie verwijderen",
  textDeletCat:
    "Door deze categorie te verwijderen, worden de uitdagingen in deze categorie verwijderd. Na deze actie kan het niet meer ongedaan worden gemaakt.",
  deletDes: "De uitdaging verwijderen",
  textDeletDes:
    "Na het wissen van de uitdaging kan deze actie niet meer ongedaan worden gemaakt.",
  desafio: "Registreer nieuwe uitdaging",
  desafiotexto: "Uitdaging",
  textoeditDesafio: "Wie kan dat doen ?",
  textEmquem: "Op wie?",
  nome: "Naam",
  inicio: "Het spel beginnen",
  inicio2:
    "Door op deze toets te drukken komt u in het spelersregistratiescherm 👥.",
  inicio3: "Het spel gaat beginnen 🎲",
  inicio4: "Volgende",
  inicio5: "Aanpassingen en instellingen",
  inicio6: `Aanpassingen zoals: 
  
- Progressieve uitdagingen
- Verander de taal van de uitdagingen 
- Uitdagingen creëren 
- Ondersteunend 
- Onder andere.`,
  inicio7: "Einde",
  inicio8: `Word Premium en krijg toegang tot:

- 450 meer nieuwe uitdagingen 😎

- Exclusieve karakters 🦸♀️ 🧑🚒
  
- Maak uw eigen uitdagingen 📝
  
- Houd het spel bijgewerkt ✅
  
- En nog veel meer 😍`,
  inicio9: "Help",
  inicio10: "Welkom bij het spel Pittige Uitdagingen 🌶",
  inicio11: `Zie hoe gemakkelijk het is om te spelen en door menu's te navigeren in minder dan 30 seconden 😎.`,
  inicio12: "Bekijk handleiding 👍🏼",
  inicio13: "Ik wil niet... 👎🏼",
  inicio14: `Om het spel te beginnen, moet u ten minste (2) twee spelers toevoegen 😀
              
Door op de hierboven aangegeven toets te drukken 👆
  
Elke keer dat u een nieuwe gebruiker toevoegt, drukt u op dezelfde knop😘`,
  cadastrarCategory: "Registreren Categorie",
  inicio15: "Aanmaken van een nieuwe categorie",
  inicio16:
    "Stap 1 : Druk op de knop met het teken + dat zich onderaan dit scherm bevindt. Na het drukken verschijnt een venster waarin u uw nieuwe categorie kunt invoeren.",
  inicio17: "Stap 2: Voer uw nieuwe categorie in en klik op opslaan",
  inicio18:
    "Stap 3: Om deze categorie te bewerken of om de uitdagingen binnen de categorie toe te voegen, klikt u op de categorie.",
  inicio19:
    "Stap 4: Als u in het volgende scherm op de knop met de pijl ⬆️ drukt, wordt een venster geopend waarin u uw nieuwe categorie kunt bewerken.",
  inicio20:
    "Stap 5: Op het volgende scherm, door te drukken op de knop aangegeven met de pijl ⬆️, U zult de categorie te verwijderen.",
  inicio21:
    "Stap 1: Druk op de knop hieronder om een nieuwe uitdaging aan deze categorie toe te voegen",
  inicio22: "Een nieuwe uitdaging creëren",
  inicio23:
    "Stap 2: Klik op elk omcirkeld punt om in detail elk veld van het register te kennen",
  inicio24: "Tekst van de uitdaging",
  inicio25: `Schrijf de uitdaging naar je eigen smaak, en om de naam van de speler in de uitdaging te laten verschijnen, druk je gewoon op de rode knop hieronder. 
    
Het zal de volgende tekens toevoegen {nome}. 

** VERANDER DEZE NIET ** Want om de naam dienovereenkomstig weer te geven, moet deze zijn zoals hieronder beschreven ⬇️⬇️⬇️⬇️⬇️⬇️⬇️

Uitdaging: Kus de nek van {nome}`,
  inicio26: "Wie kan doen, en wie kan ontvangen",
  inicio27: `Selecteer "Beide" als de uitdaging kan worden uitgevoerd en ontvangen door deelnemers van "beide" geslachten.
  
Als de uitdaging gericht is op een genre, selecteer je gewoon het gewenste genre.
`,
  inicio28: "Tijd toevoegen aan de uitdaging",
  inicio29:
    'Als uw uitdaging een tijd heeft, sleept u gewoon het "bereik" eronder, en de waarde wordt erboven weergegeven. Nadat de tijd van de uitdaging is verstreken, wordt een geluid afgespeeld om u te laten weten dat de uitdaging voorbij is.',
  aviso12: `Hier maakt u alleen de categorie aan!
    
Om de uitdagingen toe te voegen druk je gewoon op de knop van je categorie die net is aangemaakt ⬆️⬆️⬆️⬆️⬆️`,
  voltar: "Terug",
  semDe: "Speler zonder uitdagingen",
  semDe2: `Registreer ten minste één uitdaging voor deze speler 😬. 
  
U wordt doorverwezen naar het inlogscherm.`,
  term: "Privacy",
  Potitic: "Gebruiksvoorwaarden",
  adquirited: "Verworven",
  camera: "Camera",
  galery: "Galerij",
  avatar: "Avatar",
  image: "Afbeelding",
  seletion: " Geselecteerd",
  editCategory: "Bewerk de categorie",
  frase1: "U geniet van de uitdagingen ?",
  frase2: "Hoe zit het met het uitproberen van de Premium uitdagingen?",
  //err texto

  errTexto:
    "Als u een vertaalfout hebt gevonden, verbeter dan de zin in het onderstaande veld:",
  errTitulo: "Iets vreemds opgemerkt?",
  errCorrect: "Hoe zou het in het Nederlands zijn?",
  thisLanguageIsCorrect: "Is de uitdaging in HET NEDERLANDS correct?",
  yes: "Ja",
  no: "Nee",
  errSend: "Stuur suggestie",
  share: "Deel",
  fraseShare: `Wat een Top app! Gewoon delen omdat ik weet dat jij het ook leuk zal vinden!
  Download het en vertel me dan of het niet te goed is lol...😉
  
  
  Link om te downloaden: https://desafiospicantesapp.page.link/share-app`,
  bandeira: "🇳🇱",
  morePlayer: "Met meer spelers spelen ?",
  players: "Spelers",
  carregar: "Afbeelding uploaden",
  takePhoto: "Maak een foto of selecteer een afbeelding",
  useAvatar: "Of gebruik Avatars",

  hetero: "Hetero",
  gay: "Gay",
  lesbico: "Lesbisch",

  nomeHomem1: "Naam van de man",
  nomeHomem2: "Naam van de man",
  nomeMulher1: "Naam van de vrouw",
  nomeMulher2: "Naam van de vrouw",
  messageErr: "Voeg de spelers toe 🙌",
  descricaoErr: "Voer de namen van de deelnemers in ✍️",
  why: "Vertel ons waarom...",
  later: "Evalueer later",
  txtCard1: "Jouw beurt 🔥",
  txtCard2: "Laat het gebeuren 😘",
  txtCard3: "Kom op! 😜",
  txtCard4: "Volgende uitdaging 😈",
  txtCard5: "Nog eentje! 👄",

  tituloBloco1Novo: "Ontdek de seksuele intimiteit met je partner",
  subtitulo1Novo: "Meer dan 1 miljoen tevreden koppels",
  texto1Novo:
    "Ontdek de intimiteit tussen jou en je partner en krijg toegang tot de beste spellen voor koppels! Ontgrendel nu alle spellen met verschillende categorieën, speciaal ontworpen om jullie band en liefde te versterken!",

  tituloBloco2Novo: "Nieuwe ervaringen en een sterkere relatie",
  texto2Novo1: "Geniet van meer dan 1500 uitdagingen",
  texto2Novo2: "Maak je eigen uitdagingen ",
  texto2Novo3: "Exclusieve categorieën",
  texto2Novo4: "Geen vervelende advertenties",
  texto2Novo5: "Unieke avatars",
  texto2Novo6: "Elke dag nieuwe uitdagingen",
  texto2Novo7: "Regelmatig geüpdatete spelletjes",
  tituloBloco3Novo: "Hoogste beoordeling in de categorie",
  tituloBloco4Novo: "Voordelen voor je relatie:",
  texto4Novo1: "Intimiteit",
  texto4Novo2: "Verlangen",
  texto4Novo3: "Lichtheid",
  texto4Novo4: "Aantrekkingskracht",
  texto4Novo5: "Verbinding",
  texto4Novo6: "Plezier",

  tituloBloco5Novo: "Wat koppels zeggen",
  texto5depoimentoTitulo1: "Blade Moody",
  texto5depoimento1:
    "Ik denk dat dit de beste app is die ik tot nu toe op mobiel heb gevonden, zowel erotisch als interessant. Geen enkele andere app die ik heb gezien kan hiermee vergeleken worden, dus zoek een baan en koop het. Klaag niet omdat je blut bent. Je mist hier echt goede dingen, en voor slechts $10,00 krijg je de volledige app. Het biedt betere ervaringen dan de spelletjes die je in de lokale seksshops vindt.",

  texto5depoimentoTitulo2: "Joon Rxs",
  texto5depoimento2:
    "Deze app is geweldig! Ik twijfelde of ik het wel of niet moest downloaden, maar het was zeker het beste gevoel dat we in de afgelopen tijd hebben gehad. Wat is het fijn om te weten dat we nog steeds veel dingen samen kunnen doen. 🤭 We hebben de betaalde versie getest en het is echt de moeite waard, we hadden dat niveau van plezier nog niet bereikt.",

  texto5depoimentoTitulo3: "Monique SantosRader",
  texto5depoimento3:
    "Als je je relatie wilt opfleuren, is deze app perfect! Ik had al andere apps geprobeerd, maar geen enkele beviel ons zo goed als deze. Ons voorspel was veel heter en plezieriger (stel je de rest eens voor!). Het is echt de moeite waard om de betaalde versie te kopen (als je een intensere ervaring wilt voelen), maar de gratis versie was ook verrassend goed.",

  texto5depoimentoTitulo4: "Anne Owens",
  texto5depoimento4:
    "Uitstekend! Echt heel goed... Tijdens het spel werden we zo opgewonden dat de seks veel spannender werd, het was overal genot! We kijken nu al uit naar de volgende keer 💦🔥. We raden ook de betaalde versie aan als je zoveel opwinding aankan 🤤.",
  tituloBloco6Novo:
    "Doe zoals honderden koppels wereldwijd en breng meer pit in je relatie. Ontdek meer dan 800 nieuwe uitdagingen!",
  texto6Select: "Kies je versie:",
  texto6Premium: "Premium",
  texto6Assinatura: "abonnement ",
  texto6Mensal: "maandelijks abonnement",
  texto6Anual: "jaarabonnement",
  texto6Vitalicia: "eeuwigdurende licentie",
  bePremium: "Word Premium",
  buyNew: "Koop",
  attention: "Attentie! ",
  changeGender: "Je bent van seksuele geaardheid veranderd",

  tituloAvaliacao: "Bevalt het spel?",
  textoAvaliacao: "Beoordeel en help ons om te blijven verbeteren!",
  agoraNão: "Nee, bedankt",
  enviarAvaliacao: "Verzenden",

  nomeJogo1: "Pittige Uitdagingen",
  nomeJogo2: "Waarheid of Durven",
  nomeJogo3: "Niveau van stoutheid",
  nomeJogo4: "Stoute Roulette",
  nomeJogo5: "Dagelijkse Quote",
  naughtyQuiz: "Stoute Quiz",

  playAlone: "Alleen spelen",
  estaSozinho: "Speel je alleen?",
  selectPlayer: "Selecteer de speler",

  skip: "Overslaan",
  responder: "Verzenden",
  respondaAqui: "Hier antwoorden",
  config4: "Kies avatars om te personaliseren.",

  tituloSelect1: "Alleen spelen?",
  tituloSelect2: "Beantwoord compromitterende vragen!",

  subTituloSelect1: "Wij geven je een handje!",
  subTituloSelect2: "Ontdek hoe stout je bent!",
  txtJogador1:
    "Kies je speler en ontdek begeleide solo-genotervaringen speciaal voor jou!",
  txtJogador2: "De geselecteerde speler beantwoordt de vragen",
  tituloCena: "WELKE ITEMS WIL JE GEBRUIKEN?",
  subTituloCena:
    "Heb je er geen? Tik op 'Ontvangen' en haal ze op in de partnerwinkel.",
  play: "Spelen",

  titleUserWarning: "Kies een gebruiker",
  txtUserWarning: "Kies een gebruiker om de vragen te beantwoorden",

  shareNivelDeSafadeza:
    "Hé, bekijk mijn ondeugendheidsniveau 😈 Ervaar intense genotmomenten. Jij ook 💋 Download de app nu en maak je klaar om hete uitdagingen 🔥 met je partner aan te gaan: ➡️ https://pikanteuitdagingenapp.page.link/sharelevelhot",

  shareDica:
    "Verander nu je liefdesleven! Download de app en ontdek het geheim van een pittige relatie: ➡️ https://pikanteuitdagingenapp.page.link/tipoftheday",

  resultadoQuiz1:
    "Je bent een terughoudend persoon, je houdt niet erg van stoute dingen en geeft de voorkeur aan iets romantisch!",
  resultadoQuiz2:
    "Je bent te romantisch om ondeugend te zijn en je geniet meer van de sfeer bij kaarslicht.",
  resultadoQuiz3:
    "Je bent een vrij gereserveerd persoon en gelooft in het discreet en privé houden van intieme zaken.",
  resultadoQuiz4:
    "Dit betekent niet dat je nooit een beetje stout bent, maar je geeft er de voorkeur aan om al dat vuur te bewaren voor iemand heel speciaal.",
  resultadoQuiz5:
    "Jouw warmte staat op de achtergrond, maar dat verandert niets aan het feit dat er warmte is!",
  resultadoQuiz6:
    "Je houdt ervan om nieuwe ervaringen te verkennen, maar altijd met respect en instemming.",
  resultadoQuiz7:
    "Je houdt van een hete date vol kussen en knuffels. Maar er is ook een kant van jou die ervan geniet om samen met je crush naar een film te kijken of te dineren bij kaarslicht.",
  resultadoQuiz8:
    "Je bent bereid om nieuwe en spannende dingen uit te proberen, maar altijd met verantwoordelijkheid.",
  resultadoQuiz9:
    "Je bent een gedurfde persoon en vindt het leuk om de dingen in je intieme leven af en toe wat pittiger te maken.",
  resultadoQuiz10:
    "Je geniet van alle geneugten van het leven en kent geen grenzen als het om seks gaat.",
  resultadoQuiz11:
    'Met jou is er geen slecht moment, en op elk moment is het tijd voor een snelle vrijpartij! Romantische films? Alleen als het "Vijftig Tinten Grijs" is!',
  resultadoQuiz12: `Voor jou is intimiteit een voortdurend avontuur, en je bent niet bang om risico's te nemen.`,
  mes: "Maand",
  desafiosRestantesDois: "Je hebt nog 2 Premium-uitdagingen over!",
  nenhumDesafioRestante: "Geen Premium-uitdagingen meer!",
  tornePremiumAviso1:
    "Word nu premium en geniet van 1000 Exclusieve uitdagingen!",
  tornePremiumAviso2:
    "Geniet van onbeperkte uitdagingen, exclusieve inhoud en ononderbroken plezier!",
  conteudoPremium: "Je hebt een Premium-inhoud geselecteerd!",
  aproveite4desafios:
    "Profiteer van 4 premium-uitdagingen om een exclusief genot te ervaren.",
  calculando: "Resultaten berekenen...",
  nivelRomantismo: "Je romantiek niveau is...",
  finalizar: "Voltooien",
  erroQuizTitulo: "Voer uw antwoord in",
  erroQuizFrase: "Voer uw antwoord in om door te gaan!",
  new: "Nieuwe app",

  //resposta quiz safadeza

  resQuiz1: "Zacht",
  resQuiz2: "Passievol",
  resQuiz3: "Charmant",
  resQuiz4: "Super ondeugend",

  texto6Semanal: "Wekelijks",
  weekly: "Wekelijkse Handtekening",

  tempSemanal: "Wekelijks gefactureerd",
  tempMensal: "Maandelijks gefactureerd",
  tempAnual: "Jaarlijks gefactureerd",
  tempSempre: "Eenmalige betaling",
  canceleAny: "Altijd annuleren",

  //Tela do safadrometro
  Low: "Laag",
  Medium: "Medium",
  High: "Hoog",

  lifeTime: "Levenslange toegang",
  notNow: "Niet nu, bedankt",
  match: "MATCH MET A.I.",

  dateTitle: "Wil je onze nieuwe app bekijken?",

  dateBody:
    "Wil je chatten met ondeugende 😈 bots en je flirtvaardigheden oefenen? Het wordt leuk!🔥",
  goToDate: "Probeer Date.AI nu!",

  goodForU: "WAS HET GOED VOOR JE?",
  rateOurPerformance: "Beoordeel onze prestaties tot nu toe",
  veryGood: "Heel Goed",
  veryBad: "Heel Slecht",
  feedbackChallenge: `Wat zou jou ertoe brengen om de Hot Challenges-app met andere koppels te delen en waarom?`,
  type: "Typ je antwoord hier...",
  survey: "Tevredenheidsonderzoek.",
  shareIfConfortable: `Voel je vrij om te delen met vrienden als je je er prettig bij voelt :)`,

  howToPlay: "Hoe te spelen",
  howToPlayHotChallenge:
    "Maak je klaar om het spannender te maken! Trek een uitdagingskaart en verras je partner met hete actie!",

  preGameTip1:
    "Ontketen je verlangens en creëer onvergetelijke momenten met je partner!",
  preGameTip2: "Wakker je passie aan en creëer samen onvergetelijke momenten!",
  preGameTip3:
    "Ontdek je wildste verlangens en creëer onvergetelijke herinneringen!",
  preGameTip4:
    "Laat je fantasieën de vrije loop en geniet van pure pleziermomenten!",
  selecionajoagador: "Tijd om te spelen",
  dica: "Tip",
  howToPlayNaughty:
    "Selecteer je favoriete speeltjes en voorwerpen. Draai aan het wiel en laat het lot je volgende stoute uitdaging bepalen!",
  howToPlayTruthOrDare:
    "Kies je lot: deel een waarheid of ga een gedurfde uitdaging aan. Laat het plezier beginnen!",
  howToKama1: "Ontdek Plezierposities – 365 Dagen Passie!",
  howToKama2:
    "Trek een willekeurige kaart, probeer de positie en ontdek samen nieuwe hoogten van genot!",
  kamaExplain:
    "Ontgrendel elke dag een nieuwe positie en bouw jouw ultieme passiecollectie – jouw reis naar 365 dagen onvergetelijk genot begint hier!",
  howToDo: "Hoe te doen",
  pergunta: "Vraag",
  restart: "Herstarten",
  dialogText1HotChallenges:
    "Je hebt alle beschikbare uitdagingen met de geselecteerde categorieën voltooid.",
  dialogText2HotChallenges:
    "Selecteer meer categorieën of herstart het spel met de huidige uitdagingen!",
  noChallenges: "Geen Uitdagingen!",

  objects: "Objecten",
  dialogText1NaughtyGames:
    "Je hebt alle beschikbare uitdagingen voltooid met de geselecteerde objecten.",
  dialogText2NaughtyGames:
    "Selecteer meer objecten of herstart het spel met de huidige uitdagingen!",
  unlockPremium: "Premium Ontgrendelen",
  noCategory: "Kies alstublieft ten minste één categorie om te beginnen.",
  thanksForFeedback: "Bedankt dat je ons helpt de ervaring te verbeteren!",
  categoryKamasutra: "Kies je passie en speel!",
  tap: "Tik om je positie te onthullen!",
  step: "Stapsgewijze Gids",
  shareQuizButton: "Deel je stoute niveau!",
  tryAgain: "Probeer het opnieuw",
  unlockAllFun: "Ontgrendel al het plezier",
  limitedOffer: "Speciale aanbieding voor beperkte tijd!",
  fill: "Vul je naam en die van je partner in.",

  kamaNotificationTitle: "🔥 Je nieuwe kaart is ontgrendeld!",
  kamaNotificationBody:
    "Jouw positie voor dag {variavel} is klaar. Zin om vandaag iets nieuws te proberen? 💋",

  titleNewGame: "Maak je klaar voor Roleplay!",
  phraseNewGame:
    "In de volgende update komt er een nieuw spel om je meest creatieve fantasieën te verkennen. Kies personages, creëer verhalen en breng het plezier naar een hoger niveau met je partner. 🔥",
  awaitNewGame: "Wacht af en bereid je voor op unieke momenten!",
  selectObjects:
    "Selecteer twee of meer items om je spel te personaliseren. Ontdek alles volledig.",
  soon: "Binnenkort",
  wantToBeNotify: "Ik wil op de hoogte worden gehouden.",
  ok: "OK",
  vezDe: "DRAAIEN",

  categoryLabel: "Categorie",
  descriptionLabel: "Beschrijving",

  loginConnect: "Inloggen",
  loginNoAccount: "Heb je geen account?",
  loginCreateNow: "Maak nu aan",
  loginOrConnect: "of verbind met",

  email: "E-mail",
  password: "Wachtwoord",
  loginRegister: "Registreren",
  loginAlreadyHas: "Heb je al een account?",
  enterNow: "Log nu in",

  logout: "Uitloggen",
  customerPortal: "Klantenportaal",
  installApp: "Installeer App",
  loginVideo:
    "https://desafios-picantes-bucket.dev12br.com/videos-login/holandes.mp4",
};
